export const IntegrationsV1RestrictedFlag = 'integrationsV2';